import React from "react";

function AdminPlaceholder({ title }) {
  return (
    <div>
      <h1>{title}</h1>
      <p>Этот раздел находится в разработке.</p>
    </div>
  );
}

export default AdminPlaceholder;